import {connect} from 'react-redux';
import Logout from './Logout';
import {logout} from 'modules/Auth/actions/logout';

const mapStateToProps = ({
                           auth: {accessToken},
                           user: {user}
                         }) => ({
  accessToken,
  user
});

export default connect(
  mapStateToProps,
  {logout}
)(Logout);
